export default __webpack_public_path__ + "images/assets/b4b99b2ee252599d469624acaa656a39.svg";